// Visual theme rolled per game-room. This is a pure visual skin layer —
// terrain textures, building/tank/tree colors, projectile visuals, and
// audio change per theme; gameplay, physics, and net-protocol semantics
// do not. The server picks one theme when a room is created and ships
// it inside MapDescriptor so every client in the room agrees.
//
// CROSS-CLIENT CONTRACT: mirrored manually in
// `desktop/Assets/Scripts/Protocol/Theme.cs`. Numeric values are the wire
// contract — do not reorder; append-only.
export enum Theme {
  Default = 0,
  Snow = 1,
  Desert = 2,
  Mars = 3,
  FutureWar = 4,
}

// Themes eligible for the per-match random roll. FutureWar is intentionally
// excluded — it's gated on the room name (any room with "SkyNET" in the
// title always uses it; nobody else ever rolls it).
export const ALL_THEMES: readonly Theme[] = [
  Theme.Default,
  Theme.Snow,
  Theme.Desert,
  Theme.Mars,
];

// Rooms whose name contains this token (case-insensitive) are pinned to
// FutureWar for every match and ignore the random theme roll.
export const SKYNET_ROOM_TOKEN = "skynet";

export function isSkynetRoomName(name: string): boolean {
  return name.toLowerCase().includes(SKYNET_ROOM_TOKEN);
}
